import { render, staticRenderFns } from "./input-file-bcustom.vue?vue&type=template&id=4e61d70d&"
import script from "./input-file-bcustom.vue?vue&type=script&lang=js&"
export * from "./input-file-bcustom.vue?vue&type=script&lang=js&"
import style0 from "./input-file-bcustom.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports